<template>
  <div class="flex flex-col gap-1 w-full">
    <span v-if="!!label" class="font-body-2-strong">
      {{ label }} <span v-if="isRequired" class="text-danger-600">*</span>
    </span>
    <input
      v-model="text"
      class="text-input w-full border border-accent-200 outline-none text-sm p-[10px] pl-3 rounded"
      :placeholder="placeholder"
      :data-intercom-target="dataTarget"
      :disabled="disabled"
    />
    <span
      v-if="errorMessage !== ''"
      :class="[errorClass ? errorClass : 'text-danger-600 ml-5 text-sm']"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  isRequired: {
    type: Boolean,
    default: false,
  },
  textProp: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  dataTarget: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  errorClass: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["input"]);

const text = computed({
  get() {
    return props.textProp;
  },
  set(newVal) {
    emit("input", newVal);
  },
});
</script>
